import '@/styles/globals.css';
import Layout from '@/components/layout';
import SharedServiceInstance from "@/services/shared-service";
import ScrollToTopButton from "@/components/shared/scroll-to-top-button";
import FloatingVisitorCounter from "@/components/shared/floating-visitor-counter";
import { Fragment, useEffect } from "react";
import { applyTheme, createTheme } from "@/styles/themes/utils";
import { getColor, getRandomNews } from "@/services/home-service";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Image from "next/image";
import Link from "next/link";
import SharedService from "@/services/shared-service";
import Script from "next/script";

export default function App({ Component, pageProps, ...appProps }) {
    const isLayoutNeeded = !appProps.router.pathname.startsWith(`/posts/in`) && !appProps.router.pathname.startsWith(`/release`) && !appProps.router.pathname.startsWith(`/maintenance`);
    const LayoutComponent = isLayoutNeeded ? Layout : Fragment;
    useEffect(() => {
        getColor().then((result) => {
            applyTheme(createTheme({
                primary: result['primary'],
                secondary: result['secondary'],
                textBase: result['textColor'],
                custom: result['custom']
            }));
        }
        );
        if (isLayoutNeeded) {
            setInterval(() => {
                getRandomNews().then((article) => {
                    toast.info(<Link
                        href={SharedService.getPostPath(article)}
                        className="flex items-center gap-5 z-[2000]">
                        <Image src={SharedServiceInstance.getOptimizeImage(article.photo, 'small-post-view')} alt="random-news"
                            width={100} height={50} />
                        <div>
                            <span className="font-bold">Bài viết ngẫu nhiên</span>
                            <span className="line-clamp-2">{article.metaDescription}</span>
                        </div>
                    </Link>, {
                        icon: false,
                        autoClose: 10000,
                        closeButton: true,
                        position: "bottom-right",
                        toastId: 'random-1',
                    });
                });
            }, 60000);
        }
    }, [isLayoutNeeded]);

    return (
        <>
            <Script
                async
                src="https://www.googletagmanager.com/gtag/js?id=G-FN9RF2LY81"
            />
            <Script id="google-analytics">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-FN9RF2LY81');
                `}
            </Script>
            <LayoutComponent sharedService={SharedServiceInstance}>
                <ScrollToTopButton />
                <FloatingVisitorCounter />
                <Component {...pageProps} />
            </LayoutComponent>
            <ToastContainer
                className="mb-10 z-[20000!important] md:w-[30vw!important]"
                bodyClassName={() => "text-primary"}
            />
        </>
    )
}
